import selectAllOptions from '../actions/selectAllOptions'
import focusField from '../actions/focusField'
import validateCurrentField from '../actions/validateCurrentField'

export default [selectAllOptions, focusField, validateCurrentField()]



// WEBPACK FOOTER //
// ./src/modules/client/chains/selectAllOptions.js